module.exports = __webpack_public_path__ + "static/media/tools.af2a0ecd.png";